import apiOffice from "../axios/apiOffice";

class ReminderService {
  
  static async saveReminder(body) {
    try {
      const response = await apiOffice.post(`/municipales/reminder`, body);

      if (response.status < 400) {
        return { success: true, data: response.data };
      }

      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error saving reminder:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
  
  static async getReminders() {
    try {
      const response = await apiOffice.get(`/municipales/my-reminders`);

      if (response.status < 400) {
        return { success: true, data: response.data };
      }

      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting reminder:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default ReminderService;
